import { useConfirm } from 'components/Alert/useConfirm';
import { useMutation } from 'query';
import { approve } from 'scenes/FinancePage/SA/data/queryKeyFactory';
import { approveSA } from 'scenes/FinancePage/SA/sources';

export const useApprove = () => {
  const confirm = useConfirm();

  const approveMutation = useMutation(approve(), approveSA, {
    refresh: true,
    successMessage: () => `Spend Adjustment approved`,
  });

  const handleAction = ({ id }: any) => {
    confirm({
      title: `Approve Spend Adjustment ${id}?`,
      confirmActionLabel: 'Approve',
    }).then(() => approveMutation.mutateAsync({ id }));
  };

  return [handleAction, approveMutation];
};
